import routes from './routes.json';
import funnelRoutes from './funnel-routes.json';

/*
 * THE one allow-list of pages where the Meta Pixel may load or fire (src/lib/metaPixel.ts): the public marketing pages (routes.json), the ad landing
 * pages (funnel-routes.json) and the sign-up page. Exact paths, never a prefix: an app screen, an owner page, a client's quote, invoice or
 * change-order link, /guest/*, signing, payment, a request form, the platform console and /unsubscribe are never on it.
 */
/** /login is not on it: returning owners sign in there (not a funnel step), and a session that ends in the app lands there with the app address as referrer. */
const SIGN_UP_PAGES = ['/register'];

/** Pages that also need the visitor to be known signed out (a signed-in user is redirected from them into the app). */
export const SIGNED_OUT_ONLY = new Set<string>(SIGN_UP_PAGES);

const ALLOWED = new Set<string>([...routes.routes, ...funnelRoutes.routes, ...SIGN_UP_PAGES]);

/** `/pricing/` counts as `/pricing`; `/` stays `/`. */
const normalize = (pathname: string): string => (pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname);

export function isMetaPixelPath(pathname: string): boolean {
  return ALLOWED.has(normalize(pathname));
}

export function needsSignedOut(pathname: string): boolean {
  return SIGNED_OUT_ONLY.has(normalize(pathname));
}
